import { post } from "../api_helper";
import { POSTFREELACERURL,POSTRECUITERURL } from "../url_helper";

export const createfreelacerapi =(payload)=> post(`${POSTFREELACERURL}`,payload);
export const createrecuiterapi =(payload)=> post(`${POSTRECUITERURL}`,payload);
